import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export default function Publications(props) {

  const PublicationCitation = ({ author, year, title, link, journal, volume, issue, pages, pdfPath }) => {
    return (
        <li style={{ marginTop: '1em' }}>
          {author}, {year && year + "."} <a href={link} target="_blank" rel="noreferrer">{title}</a>. {journal && <i>{journal}. </i>}{volume && <b>{volume}</b>}{issue && "(" + issue + ")"}{pages && ": " + pages + ". "}
          {pdfPath &&
            <Link 
              href={pdfPath} 
              target="_blank" 
              rel="noopener" 
              aria-label="View PDF"
            >
              <PictureAsPdfIcon fontSize="small" /> 
            </Link>
          }
        </li>
    );
  };

  const publicationData = [
    {
      author: 'Crossett, C.C., G.A. Hodgkins, H. Menk, L.-A. Dupigny-Giroux, R. Dudley, M. Lemcke-Stampone, J. Hammond',
      year: '2023',
      title: 'Groundwater recharge in northern New England: Meteorological drivers and relations with low streamflow',
      link: 'https://onlinelibrary.wiley.com/doi/10.1002/hyp.14832',
      journal: 'Hydrologiocal Processes',
      volume: '37',
      issue: '3',
      pages: '1-13',
      pdfPath: 'https://nedews.nrcc.cornell.edu/vt/docs/Crossett_etal_2023_GWRechargeinNNE.pdf',
    },
    {
      author: 'Oswalda, E.M., J. Pontiusb, S.A. Raybacka, P.G. Schabergc, S.H. Wilmotd, L.-A. Dupigny-Giroux',
      year: '2018',
      title: 'The complex relationship between climate and sugar maple health: Climate change implications in Vermont for a key northern hardwood species',
      link: 'https://www.sciencedirect.com/science/article/pii/S0378112718300963?via%3Dihub',
      journal: 'Forest Ecology and Management',
      volume: '422',
      issue: '2018',
      pages: '303-312',
      pdfPath: 'https://nedews.nrcc.cornell.edu/vt/docs/FEM_Oswald_et_al_2018.pdf',
    },
    {
      author: 'Dupigny-Giroux, L.-A.',
      year: '2009',
      title: 'Backward Seasons, Droughts and Other Bioclimatic Indicators of Variability',
      link: 'https://www.researchgate.net/publication/265427379_Backward_Seasons_Droughts_and_Other_Bioclimatic_Indicators_of_Variability',
      journal: 'Historical Climate Variability and Impacts in North America',
      pdfPath: 'https://nedews.nrcc.cornell.edu/vt/docs/dupigny-giroux_backward_seasons.pdf',
    },
    {
      author: 'Dupigny-Giroux, L.-A.',
      year: '2007',
      title: 'Using AirMISR data to explore moisture-driven land use-land cover variations at the Howland Forest, Maine — A case study',
      link: 'https://www.sciencedirect.com/science/article/pii/S0034425706004135',
      journal: 'Remote Sensing of Environment',
      volume: '107',
      issue: '2007',
      pages: '376-384',
      pdfPath: 'https://nedews.nrcc.cornell.edu/vt/docs/RSE_AirMISR.pdf',
    },
    {
      author: 'Dupigny-Giroux, L.-A.',
      year: '2002',
      title: "Climate Variability and Socioeconomic Consequences of Vermont's Natural Hazards: A Historical Perspective",
      link: 'https://vermonthistory.org/journal/70/vt701_204.pdf',
      journal: 'Vermont History',
      volume: '70',
      issue: 'Winter/Spring 2002',
      pages: '19-39',
      pdfPath: 'https://nedews.nrcc.cornell.edu/vt/docs/vt701_204.pdf',
    },
    {
      author: 'Dupigny-Giroux, L.-A.',
      year: '2001',
      title: 'Towards Characterizing and Planning for Drought in Vermont - Part I: A Climatological Perspective',
      link: 'https://onlinelibrary.wiley.com/doi/10.1111/j.1752-1688.2001.tb05489.x',
      journal: 'Journal of the American Water Resources Association',
      volume: '37',
      issue: '3',
      pages: '505-525',
      pdfPath: 'https://nedews.nrcc.cornell.edu/vt/docs/drought_1_JAWRA.pdf',
    },
    {
      author: 'Dupigny-Giroux, L.-A.',
      year: '2001',
      title: 'Towards Characterizing and Planning for Drought in Vermont - Part II: Policy Implications',
      link: 'https://onlinelibrary.wiley.com/doi/10.1111/j.1752-1688.2001.tb05490.x',
      journal: 'Journal of the American Water Resources Association',
      volume: '37',
      issue: '3',
      pages: '527-531',
      pdfPath: 'https://nedews.nrcc.cornell.edu/vt/docs/drought_2_JAWRA.pdf',
    },
    {
      author: 'Dupigny-Giroux, L.-A.',
      year: null,
      title: 'Exploring Moisture Indices for Characterizing Drought in Vermont',
      link: 'https://nedews.nrcc.cornell.edu/vt/docs/41291.pdf',
      journal: null,
    },
    {
      author: 'Dupigny-Giroux, L.-A., and J.E. Lewis',
      year: '1999',
      title: 'A Moisture Index for Surface Characterization over a Semiarid Area',
      link: 'https://www.researchgate.net/publication/265249039_A_Moisture_lndex_for_Surface_Gharacterization_over_a_Semiarid_Area',
      journal: 'Photogrammetric Engineering & Remote Sensing',
      volume: '65',
      issue: '8',
      pages: '937-945',
      pdfPath: 'https://nedews.nrcc.cornell.edu/vt/docs/1999_aug_937-945.pdf',
    },
    {
      author: 'Dupigny-Giroux, L.-A.',
      year: '1999',
      title: 'Drought Follows the Deluge in Vermont',
      link: 'https://digitalcommons.unl.edu/droughtnetnews/41/',
      journal: 'Drought Network News',
      volume: '11',
      issue: '2',
      pages: '8-14',
      pdfPath: 'https://nedews.nrcc.cornell.edu/vt/docs/drought_deluge_1999.pdf',
    },
  ];

	return (
    <>
      <Typography sx={{mt:2, fontWeight:'bold'}}>
        Selected publications:
      </Typography>
      <ul style={{marginTop: 0}}>
        {publicationData.map( (info) => (
          <PublicationCitation {...info} />
        ))}
      </ul>
    </>
  )
}